/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationStatisticsResponse {
    getFixupPrototypeFunction() { return RecommendationStatisticsResponse.fixupPrototype; }

    static newInstance(model: Partial<RecommendationStatisticsResponse>): RecommendationStatisticsResponse {
        let obj = Object.assign(new RecommendationStatisticsResponse(), model);
        RecommendationStatisticsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationStatisticsResponse>): RecommendationStatisticsResponse {
        if (!model) return null;
        return RecommendationStatisticsResponse.newInstance(<RecommendationStatisticsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationStatisticsResponse) {
        if (!obj) return;

        models.RecommendationStatisticsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationStatisticsResponse): boolean {
        Object.setPrototypeOf(obj, RecommendationStatisticsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.pre_identified_recommendations === undefined) {
            this.pre_identified_recommendations = 0;
        }
        if (this.pre_identified_savings_amount === undefined) {
            this.pre_identified_savings_amount = 0;
        }
        if (this.potential_savings_amount === undefined) {
            this.potential_savings_amount = 0;
        }
        if (this.realized_savings_amount === undefined) {
            this.realized_savings_amount = 0;
        }
        if (this.total_recommendations === undefined) {
            this.total_recommendations = 0;
        }
        if (this.realized_recommendations === undefined) {
            this.realized_recommendations = 0;
        }
        if (this.pending_for_approval === undefined) {
            this.pending_for_approval = 0;
        }
        if (this.approved_recommendations === undefined) {
            this.approved_recommendations = 0;
        }
        if (this.rejected_recommendations === undefined) {
            this.rejected_recommendations = 0;
        }
        if (this.approved_potential_savings_amount === undefined) {
            this.approved_potential_savings_amount = 0;
        }
        if (this.rejected_potential_savings_amount === undefined) {
            this.rejected_potential_savings_amount = 0;
        }
        if (this.pending_approval_potential_savings_amount === undefined) {
            this.pending_approval_potential_savings_amount = 0;
        }
        if (this.pending_approval_realized_savings_amount === undefined) {
            this.pending_approval_realized_savings_amount = 0;
        }
    }

    /**
     * Total number of pre-identified recommendations for the applied filter
     */
    pre_identified_recommendations: number;

    /**
     * Potential savings amount for the pre-identified recommendations for the applied filter
     */
    pre_identified_savings_amount: number;

    /**
     * Potential savings amount for the applied filter
     */
    potential_savings_amount: number;

    /**
     * Realized savings amount for the applied filter
     */
    realized_savings_amount: number;

    /**
     * Total number of recommendations for the applied filter
     */
    total_recommendations: number;

    /**
     * Total number of realized recommendations for the applied filter
     */
    realized_recommendations: number;

    /**
     * Number of pending approvals for the applied filter
     */
    pending_for_approval: number;

    /**
     * Number of approved recommendations for the applied filter
     */
    approved_recommendations: number;

    /**
     * Number of rejected recommendations for the applied filter
     */
    rejected_recommendations: number;

    /**
     * Potential savings amount for Approved workflow status
     */
    approved_potential_savings_amount: number;

    /**
     * Potential savings amount for rejected workflow status
     */
    rejected_potential_savings_amount: number;

    /**
     * Potential savings amount for Pending Approval workflow status
     */
    pending_approval_potential_savings_amount: number;

    /**
     * Realized savings amount for Pending Approval workflow status
     */
    pending_approval_realized_savings_amount: number;

}
